import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { TABLET_BIG } from 'Douleutaras/constants/media-queries';

import './MenuScrollableWrapper.scss';

export const MenuScrollableWrapper = ({ parentRef, headerHeight = 80, children }) => {
  const containerRef = useRef(null);
  const isMobileResolution = useMediaQuery({ maxWidth: TABLET_BIG.MIN_WIDTH - 1 });
  const [isFixed, setIsFixed] = useState(false);
  const [offsetTop, setOffsetTop] = useState(0);
  const scrollTimeoutRef = useRef(null);

  const handleScroll = () => {
    if (scrollTimeoutRef.current) {
      cancelAnimationFrame(scrollTimeoutRef.current);
    }

    scrollTimeoutRef.current = requestAnimationFrame(() => {
      if (!parentRef.current || !containerRef.current) { return; }

      const parentRect = parentRef.current.getBoundingClientRect();
      const elementHeight = containerRef.current.clientHeight;
      const parentBottom = parentRect.bottom;

      const shouldFix = parentRect.top <= headerHeight && parentBottom > headerHeight + elementHeight;

      if (shouldFix) {
        setIsFixed(true);
        setOffsetTop(headerHeight);
      } else {
        if (parentRect.top > headerHeight) {
          setIsFixed(false);
          setOffsetTop(parentRect.top);
        } else {
          setIsFixed(false);
          setOffsetTop(parentBottom - elementHeight);
        }
      }
    });
  };

  useEffect(() => {
    if (isMobileResolution) { return; }

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    handleScroll(); // Первоначальная проверка

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      if (scrollTimeoutRef.current) { cancelAnimationFrame(scrollTimeoutRef.current); }
    };
  }, [isMobileResolution]);

  return (
    <div
      ref={containerRef}
      styleName={`fixed-menu-section ${isFixed ? 'fixed' : 'static'}`}
      style={{ top: isMobileResolution ? 'auto' : offsetTop }}
    >
      {children}
    </div>
  );
};
